<template>
    <div style="box-sizing: border-box;padding: 20px 0;">
        <div class="newscontent">
            <el-breadcrumb separator-class="el-icon-arrow-right">
                <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
                <el-breadcrumb-item >新闻公告</el-breadcrumb-item>
            </el-breadcrumb>
            <div style="height: 20px;"></div>
            <div class="newsItem flx" v-for="item,index in list" @click="toDetail(item)">
                <div class="newsLeft" v-text="formatYMD(item.createtime*1000)">
                    
                </div>
                <div class="newsMiddle">
                    <div class="newsTop single" v-text="item.title"></div>
                    <div class="newsBottom single" v-text="item.intro"></div>
                </div>
                <div class="konw cursor">
                   了解更多 
                </div>
            </div>
           
        </div>
    </div>
</template>
<script>
    import {
        newsList
    } from "@/api/index.js"
    export default {
        data() {
            return {
               page:1,
               list:[]
            }
        },
        created() {
            this.getList()
          
        },
        methods: {
            formatYMD(timestamp) {
              const date = new Date(timestamp);
              const year = date.getFullYear();
              const month = String(date.getMonth() + 1).padStart(2, '0');
              const day = String(date.getDate()).padStart(2, '0');
              return `${year}-${month}-${day}`;
            },
            toDetail(e){
                let that = this
                 this.$router.push({
                     path: '/newsDetail', // 写路由path
                     query: {
                         id: e.id,
                     }
                 })
            },
            getList(){
                let that = this 
                newsList(that.page).then((res) => {
                    console.log(res)
                    if(res.code == 1){
                        that.list = res.data.data
                        that.$nextTick(() => {
                            window.scrollTo(0, 0)
                        })
                    }
                })
            }
        }
    }
</script>

<style scoped>
    .konw{
        font-weight: 400;
        font-size: 14px;
        color: #666666;
        flex:1;
        text-align: right;
        position: relative;
        top: 70px;
    }
    .newsBottom{
        margin-top: 24px;
        font-size: 14px;
        color: #666666;
        text-align: left;
        width: 1100px;
    }
    .newsTop{
        font-weight: 600;
        font-size: 20px;
        color: #2D2D2D;
        text-align: left;
        width: 1100px;
    }
    .newsLeft{
        font-size: 13px;
        color: #007AFF;
        margin-right: 50px;
    }
    .newsItem{
        width: 100%;
        height: 174px;
        background: #fff;
        box-sizing: border-box;
        padding: 50px 30px;
        margin-bottom: 20px;
    }
    .newscontent{
        width: 1460px;
        margin: 0 auto;
        min-height: 50vh;
    }
</style>